/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Tlm_1Inputs */

const en_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retrieval_engine`)
};

const ar_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محرك الاسترجاع`)
};

const bn_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retrieval_engine`)
};

const de_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrieval_Engine`)
};

const es_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motor_recuperación`)
};

const fr_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moteur_de récupération`)
};

const pt_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motor_de_recuperação`)
};

const zh_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检索引擎`)
};

const tr_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alma_motoru`)
};

const ru_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`поисковый_движок`)
};

const pl_svc_ai_integration_tlm_1 = /** @type {(inputs: Svc_Ai_Integration_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`silnik_pobierania`)
};

/**
* | output |
* | --- |
* | "retrieval_engine" |
*
* @param {Svc_Ai_Integration_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_tlm_1 = /** @type {((inputs?: Svc_Ai_Integration_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_tlm_1(inputs)
	if (locale === "bn") return bn_svc_ai_integration_tlm_1(inputs)
	if (locale === "de") return de_svc_ai_integration_tlm_1(inputs)
	if (locale === "es") return es_svc_ai_integration_tlm_1(inputs)
	if (locale === "fr") return fr_svc_ai_integration_tlm_1(inputs)
	if (locale === "pt") return pt_svc_ai_integration_tlm_1(inputs)
	if (locale === "zh") return zh_svc_ai_integration_tlm_1(inputs)
	if (locale === "tr") return tr_svc_ai_integration_tlm_1(inputs)
	if (locale === "ru") return ru_svc_ai_integration_tlm_1(inputs)
	if (locale === "pl") return pl_svc_ai_integration_tlm_1(inputs)
	return en_svc_ai_integration_tlm_1(inputs)
});
export { svc_ai_integration_tlm_1 as "svc_ai-integration_tlm_1" }